<app-base-generic-questionnaire
  [title]="'TGA.Questionnaire.GeneralQuestions.label' | translate"
  [questions]="generalQuestions"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropYear]="cropYear"
></app-base-generic-questionnaire>
